<template>
  <div class="overflowTop">
    <el-tabs v-model="activeName">
      <el-tab-pane label="赊账列表" name="credit-index"></el-tab-pane>
      <el-tab-pane label="总还款记录" name="credit-record"></el-tab-pane>
    </el-tabs>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: 'credit-index'
    };
  },
  watch: {
    $route(e) {
      this.activeName = e.name;
    },
    activeName() {
      this.$router.push({
        name: this.activeName
      });
    }
  },
  mounted() {
    this.$router.push({
      name: this.activeName
    });
  },
  activated() {
    this.activeName = 'credit-index';
  }
};
</script>
